
import { useState } from 'react';
import WheelOfFortune from './components/WheelOfFortune';
import PrizeModal from './components/PrizeModal';

export default function Home() {
  const [showModal, setShowModal] = useState(false);
  const [currentPrize, setCurrentPrize] = useState('');

  const handlePrizeWon = (prize: string) => {
    setCurrentPrize(prize);
    setShowModal(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        <div className="text-center mb-6 md:mb-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-2 md:mb-4 drop-shadow-lg">
            Колесо Фортуны
          </h1>
          <p className="text-base md:text-xl text-white/90 drop-shadow">
            Крутите колесо и выигрывайте звезды Telegram!
          </p>
        </div>

        <WheelOfFortune onPrizeWon={handlePrizeWon} />

        <div className="mt-6 md:mt-8 text-center">
          <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 md:p-6 border border-white/30">
            <div className="flex items-center justify-center gap-2 mb-3">
              <i className="ri-gift-line text-2xl md:text-3xl text-yellow-300"></i>
              <h2 className="text-lg md:text-xl font-bold text-white">Забери Telegram Stars</h2>
            </div>
            <p className="text-sm md:text-base text-white/90">
              Выигрывайте от 10 до 1000 звезд Telegram!
            </p>
          </div>
        </div>
      </div>

      <PrizeModal 
        isOpen={showModal}
        prize={currentPrize}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
}
